import React from "react";
import CytoscapeGraph from "./Cyroscape";
import CourseGraph from "./CourseGraph";
import PowerGrid from "./ThreeGraph";
import MinimalFcoseGraph from "./MinimalFcoseGrahph.js";
import TreeMapGraph from "./TreeMapGraph.js";
import EdgeBundlingDemo from "./SliderGraph.js";
import ConcentricGraph from "./concentricGrahph.js";

function App() {
    const jsonData = {
        key:"3c28b7ea-a3c1-4b60-9b53-3503f57b5d11",
        content: [
            {
                "selfIndex": 6,
                "partnerUUID": "abb8d027-87f1-453a-9280-2d929130fb08",
                "partnerIndex": 271,
                "course": [
                    {
                        "courseId": "INFOB1MNP"
                    }
                ],
                "research": []
            },
            {
                "selfIndex": 6,
                "partnerUUID": "728e5ef3-555c-4ae6-b5c4-fb3f8ee01171",
                "partnerIndex": 123,
                "course": [
                    {
                        "courseId": "INFOB1MNP"
                    }
                ],
                "research": []
            },
            {
                "selfIndex": 6,
                "partnerUUID": "02a1dba5-03e6-4529-93f0-3aa4165cfd69",
                "partnerIndex": 556,
                "course": [
                    {
                        "courseId": "INFOIMP"
                    }
                ],
                "research": []
            },
            {
                "selfIndex": 6,
                "partnerUUID": "7dd9fdff-0472-4f82-86aa-b7f7596adbdc",
                "partnerIndex": 384,
                "course": [],
                "research": [
                    {
                        "title": "The Structure of the Essential Haskell Compiler, or Coping with Compiler Complexity",
                        "uuid": "2db8f516-d082-4eb0-9526-d3fdbffacee1",
                        "pureId": 372566,
                        "url": "https://research-portal.uu.nl/en/publications/2db8f516-d082-4eb0-9526-d3fdbffacee1"
                    },
                    {
                        "title": "The architecture of the Utrecht Haskell compiler",
                        "uuid": "2cb32b96-5143-4433-8448-08f67a974104",
                        "pureId": 1861789,
                        "url": "https://research-portal.uu.nl/en/publications/2cb32b96-5143-4433-8448-08f67a974104"
                    }
                ]
            },
            {
                "selfIndex": 6,
                "partnerUUID": "31ace591-9799-42f0-aaaa-b90311bc5d59",
                "partnerIndex": 497,
                "course": [],
                "research": [
                    {
                        "title": "The Structure of the Essential Haskell Compiler, or Coping with Compiler Complexity",
                        "uuid": "2db8f516-d082-4eb0-9526-d3fdbffacee1",
                        "pureId": 372566,
                        "url": "https://research-portal.uu.nl/en/publications/2db8f516-d082-4eb0-9526-d3fdbffacee1"
                    },
                    {
                        "title": "Abstract Interpretation of Functional Programs using an Attribute Grammar System",
                        "uuid": "1e2fd557-e36f-44ff-be56-c21b393a9a78",
                        "pureId": 729297,
                        "url": "https://research-portal.uu.nl/en/publications/1e2fd557-e36f-44ff-be56-c21b393a9a78"
                    },
                    {
                        "title": "Abstract interpretation of functional programs using an attribute grammar system",
                        "uuid": "49e62288-01cd-4c56-b222-d965aea1d08b",
                        "pureId": 1143253,
                        "url": "https://research-portal.uu.nl/en/publications/49e62288-01cd-4c56-b222-d965aea1d08b"
                    },
                    {
                        "title": "The architecture of the Utrecht Haskell compiler",
                        "uuid": "2cb32b96-5143-4433-8448-08f67a974104",
                        "pureId": 1861789,
                        "url": "https://research-portal.uu.nl/en/publications/2cb32b96-5143-4433-8448-08f67a974104"
                    },
                    {
                        "title": "Abstract Interpretation of Functional Programs using an Attribute Grammar System",
                        "uuid": "9a92cb29-3108-4f4e-8664-095fc8b57a78",
                        "pureId": 2736809,
                        "url": "https://research-portal.uu.nl/en/publications/9a92cb29-3108-4f4e-8664-095fc8b57a78"
                    }
                ]
            },
            {
                "selfIndex": 6,
                "partnerUUID": "a932d4ad-1c87-46d2-82e7-683f6fbf3cd9",
                "partnerIndex": 390,
                "course": [],
                "research": [
                    {
                        "title": "Learning C# by programming games",
                        "uuid": "4a97f348-9a24-4ee3-8c95-5c39607aeb49",
                        "pureId": 636358,
                        "url": "https://research-portal.uu.nl/en/publications/4a97f348-9a24-4ee3-8c95-5c39607aeb49"
                    }
                ]
            },
            {
                "selfIndex": 6,
                "partnerUUID": "1218ed7c-7d07-439b-825a-b1f9856e39ca",
                "partnerIndex": 463,
                "course": [],
                "research": [
                    {
                        "title": "Learning C# by programming games",
                        "uuid": "4a97f348-9a24-4ee3-8c95-5c39607aeb49",
                        "pureId": 636358,
                        "url": "https://research-portal.uu.nl/en/publications/4a97f348-9a24-4ee3-8c95-5c39607aeb49"
                    }
                ]
            }
        ]
    }
    return (
        <div>
            <h1>Cola.js with React</h1>
            {/*<CytoscapeGraph />*/}
            {/*<MinimalFcoseGraph />*/}
            {<CytoscapeGraph />}
            {/*<ConcentricGraph jsonData={jsonData} />*/}
            {/*<EdgeBundlingDemo/>*/}
            {/*<TreeMapGraph/>*/}
            {/*{<PowerGrid jsonData={jsonData}/>}*/}
        </div>
    );
}

export default App;

